// @ts-nocheck
import React, { useState } from "react";
import { t } from "i18next";
import useAccount from "classes/Accounts/hooks/useAccount";
import SendStep from "components/EditDrawer/SendStep/SendStep";
import useTemplate from "hooks/useTemplate";

export default function PostSendStep(props) {
	const { account, isAdmin } = useAccount();
	const { template } = useTemplate();
	const [isInitied, setIsInitied] = useState(false);
	let post = props.object;

	const checkAppFunction = React.useCallback(() => {
		let af = "NewsPage.PostQueueStyle";

		let typeId = post.postTypeId();
		if (typeId === 4)
			af = "OffersPage.PostQueueStyle";
		else if (typeId === 14)
			af = "ProOffers.PostQueueStyle";
		return (template.getAppFunction(af));
	}, [template, post]);

	React.useEffect(() => {
		// Set the publish state when the user actually reaches this step,
		// not at component mount. The wizard mounts every step component
		// upfront, so a mount-time setAsPublished gets clobbered later by
		// the step-change autosave's setAsDraft (fired for new posts that
		// don't yet have a postId). Waiting for isActive ensures
		// setAsPublished is the LAST thing that touches `draft` before
		// post.send() runs in this same step.
		if (!props.isActive) return;
		if (!isInitied) {
			if (isAdmin() || checkAppFunction() === "Published")
				post.setAsPublished();
			else
				post.setAsToModerate();
			setIsInitied(true);
		}
	}, [props.isActive, post, isInitied, isAdmin, checkAppFunction]);

	const notify = () => {
		if (post.postTypeId() !== 13)
			return (post.notify());
		let url = "NewsNotifyCustomizeWithoutPost";
		let data = {
			title: post.title(),
			message: post.txt(),
			listUsers: post.targets(),
			author: account,
			timeToNotify: post.publishedDate()
		};
		if (new Date(post.publishedDate()) > new Date())
			url = "NewsNotifyCustomizeDelayWithoutPost";
		return (post.notify(url, data));
	};

	if (!props.isActive || !isInitied)
		return (false);

	const queries = [
		{
			queryKey: ["SendPost", "Post", post.title(), post.lastChanged()],
			queryFn: () => post.send(),
			title: t("Posts.SEND_POST"),
			required: true
		},
		{
			queryKey: ["SendNotif", "Post", post.title(), post.lastChanged()],
			queryFn: notify,
			title: t("Commons.SENDING_NOTIF"),
			disabled: !(post.notification() && post.validationModeration() === true && post.draft() === false)
		},
		{
			queryKey: ["LinkUsers", "Post", post.title(), post.lastChanged()],
			queryFn: () => post.linkTargets(),
			title: t("Commons.TARGETS"),
			disabled: post.postTypeId() !== 13 || !post.targets()?.length
		},
		{
			queryKey: ["SendPost", "Images", post.postId(), post.lastChanged()],
			queryFn: () => post.sendImages(),
			title: t("Posts.SEND_IMAGES"),
			disabled: !post.images().length && !post.rssImages().length
		},
		{
			queryKey: ["SendPost", "Videos", post.postId(), post.lastChanged()],
			queryFn: () => post.sendVideos(),
			title: t("Posts.SEND_VIDEOS"),
			disabled: !post.videos().length
		},
		{
			queryKey: ["SendPost", "Attachements", post.postId(), post.lastChanged()],
			queryFn: () => post.linkAttachements(),
			title: t("Posts.SENDING_ATTACHMENTS"),
			disabled: !post.attachements().length
		},
	];
	return (
		<SendStep
			queries={queries}
			instance={props.instance}
			isDone={props.isDone}
			setIsDone={props.setIsDone}
			setFailedStep={props.setFailedStep}
		/>
	);
}
